import React from 'react';
import {Box, Tooltip, Typography} from '@mui/material';

function overlapCounts(overlap) {
    const full = Number(overlap?.full) || 0;
    const partial = Number(overlap?.partial) || 0;
    return {full, partial, total: full + partial};
}

/**
 * Similar column: total FULL + PARTIAL count; hover shows the breakdown.
 */
export default function OverlapBadges({overlap}) {
    const {full, partial, total} = overlapCounts(overlap);
    if (total <= 0) return null;

    return (
        <Tooltip
            arrow
            title={`Equivalent: ${full}\nPartially Similar: ${partial}`}
            slotProps={{tooltip: {sx: {whiteSpace: 'pre-line'}}}}
        >
            <Box component="span" sx={{display: 'inline-block', cursor: 'default'}}>
                <Typography
                    variant="caption"
                    fontWeight={700}
                    fontFamily='"Roboto Mono", monospace'
                    color="text.secondary"
                    sx={{fontVariantNumeric: 'tabular-nums'}}
                >
                    {total}
                </Typography>
            </Box>
        </Tooltip>
    );
}
